export function setMessagesLoading (state, loading = false) {
  state.messagesLoading = loading
}

export function setMessages (state, messages) {
  state.messages = messages.data
  state.messagesCurrentPage = messages.current_page
  state.messagesLastPage = messages.last_page
  state.messagesPerPage = messages.per_page
  state.messagesTotal = messages.total
  state.messagesActiveTotal = messages.total_active
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}

export function resetViews (state, message_id) {
  const k = state.messages.map(function(e) { return e._id; }).indexOf(message_id)
  const el = state.messages[k]
  el.seen.length = 0

  state.messages.splice(k, 1, el)
}
